<template>
  <v-layout class="" column wrap style="overflow: hidden;">
    <v-toolbar dark class="toolbarcreatedadmin" style="margin-top: 20px;">
      <v-btn icon @click="previousPage()">
        <v-icon>fas fa-chevron-left</v-icon>
      </v-btn>
      <img :src="BASE_URL + 'static/icon/redcross.svg'" alt="" width="40px"> &nbsp;&nbsp;
      <v-toolbar-title>รายละเอียดการซ่อมบำรุงเครื่อง AED</v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="hidden-sm-and-down">
        <v-text-field
          hide-details
          solo
          v-model="search"
          append-icon="search"
          label="serial_number, ชื่อสถานที่, ชื่อผู้ซ่อม, ชื่อบริษัท"
          class="textfieldSearch"
          style="width: 400px;"
        ></v-text-field>
      </div>
    </v-toolbar>
    <div class="hidden-md-and-up">
      <v-text-field
        hide-details
        solo
        v-model="search"
        append-icon="search"
        label="serial_number, ชื่อสถานที่, ชื่อผู้ซ่อม, ชื่อบริษัท"
        class="textfieldSearch"
      ></v-text-field>
    </div>
    <v-layout class="pb-4" row wrap justify-center align-center style="margin-top: 20px; width: 100%; overflow-x: auto;">
      <v-data-table
        :headers="headers"
        :items="listMaintenanceAED"
        :items-per-page="limit"
        :loading="table_loading"
        hide-default-footer
        fixed-header
        class="elevation-1 mx-4 data-table-container"
        style="cursor: default; width: 100%;"
        height="450px"
      >
        <template v-slot:item.address_name="{ item }">
          {{item.address_name ? '📍 ' + item.address_name : '-'}}
        </template> 
        <template v-slot:item.company_name="{ item }">
          {{(item.company_name) ? item.company_name : '-'}}
        </template> 
        <template v-slot:item.maintenance_name="{ item }">
          {{(item.maintenance_name) ? item.maintenance_name : '-'}}
        </template> 
        <template v-slot:item.maintenance_phone="{ item }">
          {{(item.maintenance_phone) ? FormatPhoneNumber(item.maintenance_phone) : '-'}}
        </template> 
        <template v-slot:item.serial_number="{ item }">
          {{ (item.serial_number) ? item.serial_number : '-' }}
        </template>
        <template v-slot:item.create_at="{ item }">
          {{ item.create_at ? dateMoment(item.create_at) : '-'}}
        </template>
        <template v-slot:item.maintenance_detail="{ item }">
          {{ (item.maintenance_detail) ? item.maintenance_detail : '-' }}
        </template>
        <template v-slot:loading>
          <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
        </template>
      </v-data-table>
     <v-pagination v-if="listMaintenanceAED.length !== 0" color="#a81000" v-model="page_pagination" :total-visible="7" :length="total_page"></v-pagination>
    </v-layout>
  </v-layout>
</template>
<script>
var _ = require('lodash')
import { Decode, Momenttime } from '@/services'
export default {
  data () {
    return {
    BASE_URL: process.env.BASE_URL,
    items: [],
    search: '',
    headers: [
      { text: 'ชื่อสถานที่', value: 'address_name' },
      { text: 'ชื่อบริษัท', value: 'company_name' },
      { text: 'ชื่อผู้ดูแล', value: 'maintenance_name' },
      { text: 'เบอร์โทรผู้ดูแล', value: 'maintenance_phone' },
      { text: 'Serial Number', value: 'serial_number' },
      { text: 'วันเวลาที่สร้าง', value: 'create_at' },
      { text: 'รายละเอียดการซ่อมบำรุง', value: 'maintenance_detail' }
    ],
    listMaintenanceAED: [],
    page_pagination: 1,
    limit: 10,
    total_page: 0,
    dialogshow_historyDetail: false,
    table_loading: false
  }},
  watch: {
    page_pagination () {
      window.history.replaceState(null, null, "?page=" + this.page_pagination + "&search=" + this.search)
      this.getlistMaintenanceAED()
    },
    search () {
      this.page_pagination = 1
      this.getlistMaintenanceAED()
      window.history.replaceState(null, null, "?page=" + this.page_pagination + "&search=" + this.search)
    }
  },
  created () {
    this.page_pagination = parseInt(this.$route.query.page)
    this.getlistMaintenanceAED()
  },
  computed: {
  },
  methods: {
    dateMoment(data) {
      return Momenttime.momentdatethai(data)
    },
    timeMoment(data) {
      return Momenttime.momenttimethai(data)
    },
    getlistMaintenanceAED () {
      this.table_loading = true
      var textparams = '?page='+this.page_pagination + '&limit='+this.limit + '&search='+this.search 
      this.$api.getlistMaintenanceAED(textparams).then((response) => {
        if (response.data.status == 200) {
          const data = response.data.data
          this.listMaintenanceAED = data.list_item
          this.total_page = response.data.data.total_page
          this.table_loading = false
        }
      }).catch((error) => {
        this.table_loading = false
      })
    },
    FormatPhoneNumber(phone) {
      if (phone == 'Null') return '-'
      const m = phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      const limits = [3, 3, 4];

      return m ? limits.map((n, i) => m[i + 1] + (m[i + 1].length === n && m[i + 2] ? '-' : '')).join('') : '';
    },
    previousPage () {
      this.$router.push('/homepage')
    }
  }
}
</script>
<style media="screen" scoped>

>>>.theme--dark.v-text-field--solo>.v-input__control>.v-input__slot {
  border-radius: 30px;
  background: #ffffff;
  color: #a80e00;
  border-color: #a80e00;
  border-style: solid;
  border-width: thin;
}
.inputinfor_address {
  height: 110px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: white !important;
}
.inputinfor {
  height: 50px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: white !important;
}
.inputinfor_dis {
  height: 50px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: #FAF0F0 !important;
}
>>>.theme--dark.v-select .v-select__selections {
  color: #a80e00 !important;
}
>>>.theme--dark.v-label {
  color: hsl(5, 100%, 33%) !important;
}
>>>.theme--dark.v-icon {
  color: #a80e00 !important;
}
>>>.theme--dark.v-input:not(.v-input--is-disabled) input {
  color: #a80e00 !important;
}
>>>.v-select__selections {
  line-height: 26px !important;
}
>>>.v-select__selection--comma {
  color: #a80e00 !important;
}
>>>.v-input .v-label {
  height: 26px;
  line-height: 26px;
}
>>>.v-list-item__title {
  line-height: 26px !important;
}
.toolbarcreatedadmin {
  border-top-color: transparent !important;
  border-left-color: transparent !important;
  border-width: thin !important;
  border-right-color: transparent !important;
  border-style: solid !important;
  height: 64px !important;
  border-left-style: initial !important;
  border-right-style: initial !important;
  border-radius: 0px !important;
  border-bottom-color: #a80e00 !important;
  background-color: white !important;
  color: #a80e00 !important;
  border-width: thin !important;
  box-shadow: none !important;
}

.btngen {
  background-color: white !important;
  color: #a80f00 !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  text-transform: none !important;
  width: 120px !important;
}
.btncreateuser {
  background-color: #a80f00 !important;
  color: #fafafa !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  text-transform: none !important;
}
.btncreateuser:disabled {
  background-color: #a80f0099 !important;
  color: #fafafa9c !important;
  border-color: #a80f0091 !important;
  border-style: solid !important;
  border-width: thin !important;
}

.btncancle {
  background-color: #fafafa !important;
  color: #a80f00 !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  width: 160px !important;
}

>>>.theme--light.v-data-table thead tr:last-child th {
  border-bottom: thin solid rgba(0,0,0,.12);
  background: #a80e00 !important;
  color: white !important;
}
>>>.v-data-table__wrapper {
  border-radius: 14px;
}

>>>.theme--light.v-data-table {
  border-radius: 14px !important;
  margin-bottom: 20px !important;
}

.textfieldSearch {
  width: 330px;
  display: -webkit-inline-box;
  margin-right: 20px;
}

.textfieldSelect {
  width: 200px;
  display: -webkit-inline-box;
  margin-right: 20px;
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px), (min-width: 768px) and (max-width: 1024px)  {
  .textfieldSearch {
    width: 80vw;
    margin-top: 20px;
    display: -webkit-inline-box;
    margin-right: 20px;
    border-radius: 30px;
    background: #ffffff;
    color: #a80e00;
    border-color: #a80e00;
    border-style: solid;
    border-width: thin;
  }
  .textfieldSelect {
    width: 80vw;
    margin-top: 20px;
    display: -webkit-inline-box;
    margin-right: 20px;
     border-radius: 30px !important;
    background: #ffffff !important;
    color: #a80e00 !important;
    border-color: #a80e00 !important;
    border-style: solid !important;
    border-width: thin !important;
  }
}

>>>.primary {
  background-color: #a81000 !important;
  border-color: #a81000 !important;
}

>>>.theme--light.v-data-table tbody tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #ffe6e6 !important;
}
>>>.v-data-table-header-mobile{
  display: none !important;
}

>>>.v-application .primary {
    background-color: #a81000 !important;
    border-color: #a81000 !important;
}
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
>>> .v-list-item__title {
  line-height: 26px !important;
  font-family: 'Kanit', sans-serif !important;
}
</style>



// WEBPACK FOOTER //
// src/components/listReport/ListMaintenanceAED.vue